import * as React from 'react';
import MaterialTable from '../../MaterialTable';
import LotWarehouseDetailTable from '../../organisms/LotWarehouseDetailTable';
import { useTransportToWarehouseColumns } from '../../../hooks/useColumns';
var TransportToWarehousesTable = function (_a) {
    var offerList = _a.offerList;
    var transportToWarehouseColumns = useTransportToWarehouseColumns();
    var columns = React.useMemo(function () { return [
        transportToWarehouseColumns.warehouseName,
        transportToWarehouseColumns.status,
        transportToWarehouseColumns.ordersCount,
        transportToWarehouseColumns.ordersTotalQuantity,
        transportToWarehouseColumns.ordersTotalWeight,
        transportToWarehouseColumns.typicaStockTotalQuantity,
        transportToWarehouseColumns.typicaStockTotalWeight,
    ]; }, [transportToWarehouseColumns]);
    var handleClickDetail = React.useCallback(function (transportToWarehouse) {
        var warehouseId = transportToWarehouse.warehouse.id;
        return "/admin/offer_lists/".concat(offerList.id, "/warehouses/").concat(warehouseId, "/orders");
    }, [offerList.id]);
    var detailPanel = React.useCallback(function (_a) {
        var rowData = _a.rowData;
        if (!offerList)
            return;
        return (React.createElement(LotWarehouseDetailTable, { warehouse: rowData.warehouse, offerList: offerList }));
    }, [offerList]);
    return (React.createElement(MaterialTable, { model: "warehouse", columns: columns, data: offerList.transportToWarehouses || [], detailPath: handleClickDetail, detailPanel: detailPanel }));
};
export default TransportToWarehousesTable;
